import React from 'react';
import ParticipantAccountSubProgramCard from './components/ParticipantAccountSubProgramIndex.jsx';

const ParticipantAccountSubProgram = ({program}) => {
  return (
      <ParticipantAccountSubProgramCard program={program} />
  )
}

export default ParticipantAccountSubProgram;
